import { defineStore } from 'pinia'

export const useBannerStore = defineStore('banner', {
  state: () => ({
    showMaintenanceBanner: false,
    showAnnounceBanner: true,
    showPoliticAndConfidentialityBanner: true,
    showTermsBanner: true
  })
})
